import { removeClass } from '@opten/dom/remove-class';
import { Component } from '@opten/compiler/metadata/component';
import { setCookie } from '@opten/cookie/set';
import { getCookie } from '@opten/cookie/get';

@Component({ className: 'js-cookie-consent' })
export class CookieBannerComponent {
	private cookieKey: string;

	constructor(private element: HTMLElement) {
		this.cookieKey = this.element.getAttribute('data-cookie-key');
		if (!this.cookieKey) {
			this.cookieKey = 'cookiesAccepted';
		}

		if (getCookie(this.cookieKey) !== 'true') {
			Array.from(this.element.querySelectorAll('.js-cookie-consent-approve'))
				.forEach((btn) => btn.addEventListener('click', (e) => {
					e.preventDefault();
					this.accept();
				}));
		} else {
			this.hide();
		}
	}

	private accept() {
		setCookie(this.cookieKey, 'true', Infinity, '/');
		this.hide();
	}

	private hide() {
		removeClass(this.element, 'is-open');
	}
}
